import { atom, atomFamily } from 'recoil';
import type { RecoilState } from 'recoil';

import {
  broadcastChannelSynchronizerEffect,
  localStoragePersisterEffect,
} from 'utils/recoilEffects';

export const recorderState: RecoilState<boolean> = atom({
  key: 'recorderState',
  default: false,
  effects: [broadcastChannelSynchronizerEffect()],
});

/**
 * Tracks whether user has started recording for a given case.
 *
 * Cross-window sync: Recording starts in the reporter window, but the viewer
 * window needs to know if recording has happened. This is used as a proxy for
 * when the user is 'done' hanging their study the way they like it.
 */
export const hasRecordedForCaseAtom = atomFamily<boolean, string>({
  key: 'hasRecordedForCaseAtom',
  default: false,
  effects: [
    broadcastChannelSynchronizerEffect({ conductor: 'reporter' }),
    localStoragePersisterEffect(),
  ],
});
